<div mat-dialog-title></div>
<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144074' | translate }} {{ title | translate }}</h2>

  <div mat-dialog-content class="m-0">
    <form [formGroup]="editForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="true">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143909' | translate}}</mat-label>
            <input matInput [readonly]="!isCreate" placeholder="{{'ml_144097' | translate}}" formControlName="terminalId" (keyup)="onTerminalIdKeyUp($event)" />
          </mat-form-field>
        </div>
        <div class="col">
          <div class="mt-3">{{ editForm.controls["terminalName"].value }}</div>
          <!-- <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'ml_143910' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="terminalName" />
          </mat-form-field> -->
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <app-terminal-search-grid [filterText$]="terminalIdFilter$" (itemToggled)="onTerminalItemClicked($event)"></app-terminal-search-grid>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'ml_143912' | translate}}</mat-label>
            <input matInput readonly placeholder="" formControlName="country" />
          </mat-form-field>
        </div> -->
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ ('ml_143911' | translate)}}</mat-label>
            <mat-select formControlName="subregion_id" [disabled]="country === '' ">
              @for (item of subRegionsBySelectedCountry$ | async; track $index) {
              <mat-option [value]="item.subRegion_Id">
                {{ item.subRegionName }}
              </mat-option>
              }
            </mat-select>
            <mat-hint *ngIf="(subRegionsBySelectedCountry$ | async)?.length==0" align="start"><strong>{{'ml_144150' | translate}}</strong> </mat-hint>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="row m-0 p-2 justify-content-end">
    <spinner-button class="me-3 col-auto" [refreshState$]="processing$" [disabled]="editForm.invalid" label="{{ 'ml_143934' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
      (clicked)="onOkClick()">
    </spinner-button>
    <button (click)="onCancelClick()" class="button--default button-back col-auto attachment-select">{{ 'ml_143935' | translate }}</button>
  </div>
</div>
